import { render } from "./contracts-table.vue?vue&type=template&id=5c7fe5d4"
import script from "./contracts-table.vue?vue&type=script&lang=js"
export * from "./contracts-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__